<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :value="'添加'" @click="goToAdd" v-if="permissionCodes.indexOf('041003001') !== -1"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination"  :operationArr="operationArr" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Group";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "customer-master-data",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "数据对接",
          name: "customer-master-data"
        },
        {
          value: " 利润/成本中心"
        }
      ],
      tableHead: [
        {
          prop: "costCenterCode",
          label: "成本中心代码"
        },
        {
          prop: "costCenterDescCn",
          label: "成本中心描述"
        },
        {
          prop: "companyName",
          label: "关联主体住户"
        }
      ],
      tableData: [],
      total: 1,
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      operationArr: ["modify", "delete"]
    };
  },
  created() {
    this.getPage();
    this.permissionCodes = bus.global.permissionCodes;
  },
  methods: {
    changePagination(data) {
      this.requestData.pageSize = data[1];
      this.requestData.pageNum = data[0];
      this.getPage();
    },
    getPage() {
      this.$axios
        .post(api.getDaliCostCenterPage, this.requestData)
        .then(res => {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(errorHandler("获取分页失败"));
    },
    goToAdd() {
      this.$router.push({
        name: "cost-center-add"
      });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteDaliCostCenter, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },
    goToModifyPage(code) {
      let _data = {};
      this.tableData.map(v => {
        if (v.code == code) {
          _data = v;
        }
      });
      this.$router.push({
        name: "cost-center-modify",
        params: {
          data: _data
        }
      });
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/view/DataSync/CostCenter/CostCenter.vue